<template>
    <div class="col-12 nopads">
        <top-bar
            @onSignInClicked="showLogin" />
        <alert
            :show="alertVisible"
            :message="message"
            :variant="variant"
            @alertShown=alertShown
        />
        <div class="col-12 main-container">
            <div v-if="!showLoginForm" class="col-xl-10 content-container mx-auto">
                <div v-if="campaign" class="mx-auto">
                    <bread-crumbs :breadcrumbs="this.breadcrumbs" />
                    <b-container class="mt-2 mb-4 no-gutters">
                        <!-- Header with photo and campaign name -->
                        <div class="content-header-container"
                             v-bind:style="{ backgroundImage: 'url(' + campaignBackground + ')' }">
                            <div class="content-header-container-overlay">
                                <transition name="fade">
                                    <div v-if="!campaignBackground" class="header-img-overlay">
                                    </div>
                                </transition>
                                <h3 class="content-header-title palette-white pb-5">{{ campaign.team ? campaign.team.name : "" }}</h3>
                                <h4 class="content-header-subtitle palette-white">{{ campaign.name }}</h4>
                            </div>
                        </div>
                        <!-- Ended campaign -->
                        <div v-if="campaignEnded()" class="col-12">
                            <span class="card-title p-0 pt-2">{{ $t('campaign.campaign_ended') }}</span>
                        </div>
                        <!-- Campaign data -->
                        <b-col md="8" offset-md="2" v-else>
                            <div class="col-sm-12 pt-5 text-center" v-if="isStarted()">
                                <b-button
                                    @click="donate"
                                    class="campaign_donate_button">
                                    {{ $t('campaign.donate') }}
                                </b-button>
                            </div>
                            <h3 class="info-subtitle palette-primary mt-5 mb-3">{{ campaign.organization.name}}</h3>
                            <div v-if="campaign.user">
                                <span class="title">{{ $t('campaign.user')}}</span>
                                <p class="p-small">{{ campaign.user.first_name }} {{ campaign.user.last_name }}</p>
                            </div>
                            <div v-if="campaign.team">
                                <span class="title">{{ $t('campaign.organization')}}</span>
                                <p class="p-small">{{ campaign.team.name}}</p>
                            </div>
                            <!--
                            <div v-if="campaign.end_date">
                                <span class="title">{{ $t('campaign.ends_on')}}</span>
                                <p class="p-small">{{ getShortDateString(campaign.end_date) }}</p>
                            </div>
                            -->
                            <span class="title">{{ $t('campaign.description')}}</span>
                            <pre class="p-large">{{ campaign.description }}</pre>
                            <span class="title">{{ $t('campaign.license')}}</span>
                            <p class="p-large">{{ campaign.organization.license ? campaign.organization.license : '-' }}</p>
                            <span class="title">{{ $t('campaign.link')}}</span>
                            <p class="p-large">
                                {{ getLink() }}
                                <span class="pl-2"><font-awesome-icon icon="copy" class="pointer"
                                                                      @click.stop="copyLink()"/> </span>
                            </p>
                            <div class="col-sm-12 pt-4 text-center"
                                 v-if="!isStarted()">
                                <span class="title mt-2">
                                    {{$t('campaign.will_start')}}
                                    {{ new Date(this.campaign.startDate).toLocaleDateString()}}</span>
                            </div>
                        </b-col>
                    </b-container>
                </div>
                <div v-else>
                    <no-results v-if="!loading"></no-results>
                </div>
            </div>
            <login v-if="showLoginForm"
                   @loginUser="hideLogin"
                   @close="hideLogin"
                   @alert="showAlert">
            </login>
            <footer-area />
        </div>
        <b-modal
                v-if="campaign"
                v-model="showModal"
                id="modal-tall"
                hide-footer
                no-close-on-backdrop
                no-close-on-esc
                centered
                :title="$t('payment.make_donation')"
                @close="hideModal"
                size="lg">
            <payment :campaign-id="campaign.id"/>
        </b-modal>

        <div v-if="loading"
             id="loader"
             class="spinner">
        </div>
    </div>
</template>
<script>
    import {userHelper} from "../mixins/UserMixin";
    import {views} from "../mixins/ViewMixin";
    import TopBar from "../components/TopBar";
    import {timeMixin} from "../mixins/TimeMixin";
    import FairApi from "../modules/api";
    import Payment from "../components/payment/Payment";
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    import Login from "../components/Login";
    import NoResults from "../components/NoResults";
    import {alertMixin} from "../mixins/AlertMixin";
    import Alert from "../components/Alert";
    import FooterArea from "../components/FooterArea";
    import BreadCrumbs from "@/components/BreadCrumbs";
    Vue.use(VueClipboard)

    export default {
        name: "campaign-info-view",
        mixins: [userHelper, views, timeMixin, alertMixin],
        components: {BreadCrumbs, Alert, NoResults, Login, Payment, TopBar, FooterArea},
        props: {
            id: {
                type: [Number, String],
                default: 0
            }
        },

        data() {
            return {
                views,
                loading: false,
                campaign: null,
                campaignBackground: null,
                showModal: false,
                showLoginForm: false,
                breadcrumbs: []
            }
        },
        mounted() {
            if (this.id) {
                this.fetchCampaign()
            } else {
                console.log("nothing to show")
                this.fetchCampaignFailed()
            }
            // Check payment status and show message if needed
            let payment = this.$route.query.payment
            if (payment && parseInt(payment) === 0) {
                console.log("Failed ")
                this.showAlert(this.$t('payment.failed_payment'))
            }
        },

        methods: {
            isStarted: function () {
                return (new Date() > new Date(this.campaign.startDate))
            },

            fetchCampaign: function () {
                this.loading = true
                FairApi.get(FairApi.campaign(this.id), this.fetchCampaignSuccess, this.fetchCampaignFailed)
            },

            fetchCampaignSuccess: function (response) {
                this.campaign = response
                this.loading = false
                this.fetchBackgroundImage()
                this.setBreadcrumbs()
            },

            fetchCampaignFailed: function () {
                this.loading = false
                this.showAlert(this.$t('common.fetch_failed'))
            },

            setBreadcrumbs: function () {
                this.breadcrumbs = [
                    {
                        text: "breadcrumbs.front_page",
                        translate: true,
                        route: 'main-view',
                        disabled: false,
                        active: false
                    },
                    {
                        text: "categories." + this.campaign.organization.category,
                        translate: true,
                        route: 'category-organizations-view',
                        disabled: false,
                        active: false,
                        params: { id: this.campaign.organization.category }
                    },
                    {
                        text: this.campaign.organization.name,
                        translate: false,
                        route: 'organization-campaigns-view',
                        disabled: false,
                        active: false,
                        params: { id: this.campaign.organization.id }
                    },
                    {
                        text: this.campaign.name,
                        translate: false,
                        route: 'team-info-view',
                        disabled: true,
                        active: true,
                    }
                ]

                // Category 4 is sports
                if(this.campaign.organization.category === 4) {
                    this.breadcrumbs[3].disabled = false
                    this.breadcrumbs[3].active = false
                    this.breadcrumbs[3].params = { id: this.campaign.team?.id }
                    this.breadcrumbs.push({
                        text: this.campaign.team.name,
                        translate: false,
                        route: 'team-info-view',
                        disabled: true,
                        active: true
                    })
                }
            },

            fetchBackgroundImage() {
                if (this.campaign.photo) {
                    FairApi.get(FairApi.photo(this.campaign.photo.id), this.success, function () {
                    })
                }
            },

            success(response) {
                this.campaignBackground = response
            },

            donate() {
                this.showModal = true
            },

            hideModal() {
                this.showModal = false
            },

            campaignEnded() {
                return this.campaign.active !== true || this.isDatePassed(this.campaign.endDate);
            },

            getLink() {
                let url = new URL(window.location.href)
                return 'https://' + url.hostname + '/campaign/' + this.campaign.id
            },

            copyLink: function () {
                this.$copyText(this.getLink())
            },

            showLogin() {
                this.showLoginForm = true
                this.showModal = false
            },

            hideLogin() {
                this.showLoginForm = false
            }
        }
    }
</script>

<style scoped>
    pre {
        word-wrap: break-word; /* IE 5.5-7 */
        white-space: -moz-pre-wrap; /* Firefox 1.0-2.0 */
        white-space: pre-wrap; /* current browsers */
        overflow-x: hidden !important;
        overflow-y: hidden !important;
        text-align: justify;
    }
</style>